// extracted by mini-css-extract-plugin
export var labelledNotchedOutlined = "LabelledOutline-module--labelledNotchedOutlined--ab015";